export default __webpack_public_path__ + "static/media/photo-mobile.caedba7b.jpeg";